import './context-fields-area.scss'

import { FormApi } from 'final-form';
import Vue from "vue";
import Component from "vue-class-component";

import { Signer } from '@skinsoft/entity';
import { ReportFeatured } from '@skinsoft/entity-ui';
import { DatePicker, EnhancedTextArea, EnhancedTextInput, Form, getTranslatedString } from '@skinsoft/ui';

import { Signers } from '../signers';

@Component({
    components: {
        sDatePicker: DatePicker,
        sEnhancedTextArea: EnhancedTextArea,
        sEnhancedTextInput: EnhancedTextInput,
        sSigners: Signers,
    },
    props: ["reportFeatured", "form", "fieldName", "signers"],
    template: require("./context-fields-area.html")
})
export class ContextFieldsArea extends Vue {

    public reportFeatured: ReportFeatured;
    public fieldName: string;
    public signers: Signer[];

    public form: FormApi;

    // getters returning fields name according to data path in condition report object
    public get dateFieldName() {
        return `${this.fieldName}.conditionReportCS.reportDate`
    }

    public get locationFieldName() {
        return `${this.fieldName}.conditionReportCS.location.translatedString.${this.$i18n.locale}`
    }

    public get technicsAndMaterialsFieldName() {
        return `${this.fieldName}.conditionReportCS.technicsAndMaterials[0.translatedString.${this.$i18n.locale}`
    }

    public get commentsFieldName() {
        return `${this.fieldName}.conditionReportCS.generalState.translatedString.${this.$i18n.locale}`
    }
}